<div class="triple-line-chart" [id]="chartdiv_id"></div>
